// RhythmSignature: 3D animated ownership badge for "Made By Rhythm"
// Designed to be reusable across sections as a subtle but clear credit.

import styled from 'styled-components';
import { motion } from 'framer-motion';

const Wrapper = styled(motion.div)`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  perspective: 900px;
`;

const Text3D = styled(motion.span)`
  font-family: 'Monda', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.25em;
  font-size: 0.8rem;
  padding: 0.55rem 1.4rem;
  border-radius: 999px;
  background: radial-gradient(circle at top left, #bbff00, #202020 55%, #000000 100%);
  color: #050505;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.85);
  transform-style: preserve-3d;
  text-shadow: 0 0 14px rgba(187, 255, 0, 0.85);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(187, 255, 0, 0.85);
`;

const Subtitle = styled(motion.span)`
  font-family: 'Monda', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
`;

const RhythmSignature = ({ className }) => {
  return (
    <Wrapper
      className={className}
      initial={{ opacity: 0, rotateX: -65, y: 16 }}
      animate={{ opacity: 1, rotateX: 0, y: 0 }}
      transition={{ duration: 1.1, delay: 0.8, ease: [0.19, 1, 0.22, 1] }}
    >
      <Text3D
        animate={{
          rotateY: [-10, 10, -10],
          textShadow: [
            '0 0 16px rgba(187, 255, 0, 0.4)',
            '0 0 30px rgba(187, 255, 0, 1)',
            '0 0 16px rgba(187, 255, 0, 0.4)',
          ],
        }}
        transition={{ duration: 7, repeat: Infinity, ease: 'easeInOut' }}
      >
        Made By Rhythm
      </Text3D>
      <Subtitle
        initial={{ opacity: 0, x: 10 }}
        animate={{ opacity: 0.9, x: 0 }}
        transition={{ duration: 0.9, delay: 1.3 }}
      >
        Rhythm · Rhythmverse Studio
      </Subtitle>
    </Wrapper>
  );
};

export default RhythmSignature;
